import { useCallback, useEffect, useRef } from 'react';

import utils from './utils';
import toast from '../utils/toast';
import Icon from '../components/Icon';
import styles from './Base.module.scss';

const Base = ({ title, close, children }) => {

  const ref = useRef(null);

  const { setDialog } = utils.useDialog();

  const _close = useCallback(() => {

    setDialog(null);

    if (close) {
      close();
    }

  }, [setDialog, close]);

  /*
   * BLUR (click outside modal)
   */

  const _blur = useCallback((event) => {

    const target = event.target;

    if (toast.contains(target)) {
      return;
    }

    if (target.classList.contains('skip')) {
      return;
    }

    if (ref.current && !ref.current.contains(event.target)) {
      _close();
    }

  }, [_close]);

  useEffect(() => {
    document.addEventListener('click', _blur, true);
    return () => document.removeEventListener('click', _blur, true);
  }, [_blur]);

  /*
   * ESCAPE (escape key press)
   */

  const _esc = useCallback((event) => {
    if (event.key === 'Escape') {
      _close();
    }
  }, [_close])

  useEffect(() => {
    document.addEventListener('keyup', _esc, true);
    return () => document.removeEventListener('keyup', _esc, true);
  }, [_esc]);

  return (
    <>
      <div className={styles.mask}>
      </div>

      <div className={styles.area}>
        <div
          ref={ref} 
          role='dialog'
          aria-modal={true}
          aria-labelledby='heading'
          className={styles.modal}>

          <button
            className={styles.close}
            onClick={() => _close()}
            aria-label='close'>

            <Icon name='close' />

          </button>

          <h2 id='heading' className={styles.title}>
            {title}
          </h2>

          <div className={styles.content}>
            {children}
          </div>

        </div>
      </div>
    </>
  );
};

export default Base;